import React, { useState } from "react";

import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Textarea,
} from "@chakra-ui/react";

import TeamSelect from "../../../../../components/select/TeamSelect";
import client from "../../../../../helpers/Client";
import SaveButton from "../../../../../components/buttons/SaveButton";
import TaskTypeSelect from "../../../../../shared/components/IssueTypeSelect.jsx";

export default function CreateSubtaskModal({
  parentTaskId,
  ticketURL,
  resellerID,
  ticketRevalidator,
  state,
}) {
  const [title, setTitle] = useState(null);
  const [body, setBody] = useState(null);
  const [kind, setKind] = useState(null);
  const [team, setTeam] = useState(null);
  const [buttonLocked, setButtonLocked] = useState(false);
  const [errorData, setErrorData] = useState({});

  const handleCreate = () => {
    setButtonLocked(true);
    const payload = { 
      title, 
      body, 
      team, 
      kind, 
      ticket: ticketURL,
      user: null
    };
    client
      .post("/tasks/", payload)
      .then(() => {
        setButtonLocked(false);
        setErrorData({});
        ticketRevalidator.revalidate();
        state.onClose();
      })
      .catch((error) => {
        if (error?.response?.data) {
          setErrorData(error.response.data);
        } else {
          setErrorData({"non_field_errors": ["Unknown error."]})
        }
        setButtonLocked(false);
      });
  };

  const handleClose = () => {
    setErrorData({});
    state.onClose();
  };

  return (
    <Modal isOpen={state.isOpen} onClose={state.onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Alt Görev Oluştur</ModalHeader>
        <ModalCloseButton onClick={handleClose} />
        <ModalBody>
          <FormControl pb={3} isRequired isInvalid={errorData?.title}>
            <FormLabel>Başlık</FormLabel>
            <Input type="text" onChange={(e) => setTitle(e.target.value)} />
            {errorData.title &&
              errorData.title.map((e) => (
                <FormErrorMessage key={e}>{e}</FormErrorMessage>
              ))}
          </FormControl>
          <FormControl pb={3} isInvalid={errorData.body}>
            <FormLabel>Açıklama</FormLabel>
            <Textarea onChange={(e) => setBody(e.target.value)} />
            {errorData.body &&
              errorData.body.map((e) => (
                <FormErrorMessage key={e}>{e}</FormErrorMessage>
              ))}
          </FormControl>
          <FormControl pb={3} isInvalid={errorData.kind}>
            <FormLabel>Tip</FormLabel>
            <TaskTypeSelect
              option={kind}
              setOption={setKind}
            />
            {errorData.kind &&
              errorData.kind.map((e) => (
                <FormErrorMessage key={e}>{e}</FormErrorMessage>
              ))}
          </FormControl>
          <TeamSelect
            resellerID={resellerID}
            selectedTeamURL={team}
            setSelectedTeamURL={setTeam}
            selectedTeamErrorMsg={errorData.team}
          />

          {errorData.non_field_errors &&
            errorData.non_field_errors.map((e) => (
              <Text bg="red.500" color={"white"} p={2} mt={2} key={e}>
                {e}
              </Text>
            ))}
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={handleClose}>
            Vazgeç
          </Button>
          <SaveButton
            {...{
              isDisabled: title === null || buttonLocked || title?.length === 0,
            }}
            onClick={handleCreate}
          >
            Kaydet
          </SaveButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}